import './App.css';
import { About } from './components/About';
import { Home } from './components/Home';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NoteState from './context/Notes/NoteState';
import Alert from './components/Alert';
import Login from './components/Login';
import Signup from './components/Signup';
import Homepage from './components/Homepage';
import UserState from './context/Users/UserState';
import { useState } from 'react';

function App() {

  const [alert, setalert] = useState(null)

  const showalert = (message,type) => {
    setalert({
      message, type
    })

    setTimeout(() => {
      setalert(null);
    }, 2000);
  }

  return (
    <>
      <NoteState>
        <UserState>
          <Router>
            <Navbar showalert={showalert} />
            <Alert alert={alert}/>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/login" element={<Login showalert={showalert} />} />
              <Route path="/signup" element={<Signup  showalert={showalert}/>} />
              <Route path="/about" element={<About />} />
              <Route path="/home" element={<Home showalert={showalert} />} />
            </Routes>
          </Router>
        </UserState>
      </NoteState>
    </>
  );
}

export default App;
